import {
  GET_PRODUCT_SLIP_LIST_REQUEST,
  GET_PRODUCT_SLIP_LIST_RESPONSE,
  UPDATE_PRODUCT_SLIP_STATUS_BY_PRODUCT_SLIP_ID_REQUEST,
  UPDATE_PRODUCT_SLIP_STATUS_BY_PRODUCT_SLIP_ID_RESPONSE,
} from "./actionTypes";

export const getProductSlipListRequest = (filter) => {
  return {
    type: GET_PRODUCT_SLIP_LIST_REQUEST,
    payload: { filter },
  };
};

export const getProductSlipListResponse = (apiResponse) => {
  return {
    type: GET_PRODUCT_SLIP_LIST_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateProductSlipStatusByProductSlipIdRequest = (
  productSlipId,
  status
) => {
  return {
    type: UPDATE_PRODUCT_SLIP_STATUS_BY_PRODUCT_SLIP_ID_REQUEST,
    payload: { productSlipId, status },
  };
};

export const updateProductSlipStatusByProductSlipIdResponse = (apiResponse) => {
  return {
    type: UPDATE_PRODUCT_SLIP_STATUS_BY_PRODUCT_SLIP_ID_RESPONSE,
    payload: { apiResponse },
  };
};
